// Single source of truth for per-route <title> and <meta description>.
// Titles render as `${title} — 99tests` (see lib/seo.js); keep title ≤ ~45 chars, description ≤ 155.
// Slug-driven marketing pages keep their per-slug copy in their own component configs
// (Landing.jsx PAGES, Compare.jsx COMPETITORS); their canonical entries are mirrored here for reference.

export const PAGES = {
  "/": {
    // title omitted → seo.js uses the default full homepage title
    description: "Real testers run your AI-generated test cases (Cursor, Claude Code, Copilot) on real phones and browsers — a human-verified pass/fail report in 3 days.",
  },
  "/pricing": {
    title: "Pricing — real-device testing packages",
    description: "Fixed-price real-device testing on phones, laptops and browsers. From $129, or ₹9,999 + GST in India. No account or sales call; testers start within the hour; report in 3 business days.",
  },
  "/crowdsourced-testing": {
    fullTitle: "Crowdsourced testing in India: 20,000 real testers, fixed price | 99tests",
    description: "Crowdsourced testing since 2010. Real testers run your test cases on their own phones and browsers across India. Fixed price from ₹9,999 / $129, verified report in 3 business days.",
  },
  "/about": {
    fullTitle: "About 99tests: real-device testing since 2010",
    description: "99tests is a Bengaluru company running crowdsourced software testing since 2010. Real testers run your test cases on their own phones, laptops and browsers.",
  },
  "/mobile-app-testing-india": {
    fullTitle: "Mobile app testing services in India on real devices | 99tests",
    description: "Run your Android & iOS test cases on the real phones Indians own — Redmi, Realme, Galaxy, Vivo, iPhone on Jio/Airtel. Verified 3-day report.",
  },
  "/cross-browser-testing": {
    title: "Cross-browser testing on real machines",
    description: "Test your web app on Chrome, Safari, Edge and Firefox on real Windows, Mac and phones — real versions and networks. Verified 3-day report.",
  },
  "/exploratory-testing": {
    title: "Exploratory testing by real testers",
    description: "Charter-driven exploratory testing by real people on real devices — the bugs your scripted cases miss. Fixed price, verified 3-day report.",
  },
  // Landing.jsx (seoTitle/seoDesc): /real-device-testing-india, /test-ai-generated-test-cases, /vs-device-clouds-and-automation
  // Compare.jsx (per competitor): /vs/utest, /vs/testlio, /vs/browserstack-app-live, /vs/test-io, /vs/global-app-testing
  // Device.jsx (per device, src/lib/devices.js metaTitle/metaDesc): /test-app-on/:slug
};

export function getMeta(path) {
  return PAGES[path] || {};
}
